import { EVENTS } from '@archetype-themes/utils/events'

class GiftCardVariantPicker extends HTMLElement {
  constructor() {
    super()

    this.productInfo = new Map()
    this.currentVariant = null
  }

  connectedCallback() {
    this.giftCardTabWrapper = this.querySelector('.js-gift-card-style-tab')
    this.giftCardTabContents = this.querySelectorAll('.gift-card-tab-content')

    this.addEventListener('change', this.handleVariantChange.bind(this))
    this.giftCardTabWrapper.addEventListener('click', this.handleGiftCardTabClick.bind(this))
    this.init()
  }

  init() {
    const urlSearchParams = new URLSearchParams(window.location.search)
    const variantId = urlSearchParams.get('variant')
    const variants = this.getVariantData()

    if (variantId) {
      const variantId = urlSearchParams.get('variant')
      const variant = variants.find(v => `${v.id}` === variantId)

      if (variant) {
        this.currentVariant = variant
      }
    }

    if (!this.currentVariant) {
      this.currentVariant = variants[0]
    }

    const giftCardStyle = this.currentVariant.option2
    const styleInput = this.querySelector(`input[name="Style"][value="${giftCardStyle}"]`)
    const giftCardContentWrapper = styleInput.closest('[data-gift-card-category]')
    const giftCardCategory = giftCardContentWrapper.dataset.giftCardCategory
    const giftCardTab = this.giftCardTabWrapper.querySelector(`[data-gift-card-category="${giftCardCategory}"]`)

    giftCardTab.classList.add('active')
    giftCardContentWrapper.classList.add('active')
    styleInput.checked = true

    this.updateURL()
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }

  getMatch() {
    return this.getVariantData().find((variant) => {
      return this.options.every((value, index) => {
        return variant[this.getOptionName(index)] === value
      })
    })
  }

  getOptionName(index) {
    return `option${index + 1}`
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('fieldset'), (element) => {
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find(
          (radio) => radio.checked
        )?.value
      }
    })
  }

  async handleVariantChange() {
    this.updateOptions()
    this.currentVariant = this.getMatch()

    if (this.currentVariant) {
      this.updateURL()
      const html = await this.getProductInfo()

      this.dispatchEvent(
        new CustomEvent(`${EVENTS.variantChange}:${this.dataset.sectionId}:${this.dataset.productId}`, {
          bubbles: true,
          detail: {
            sectionId: this.dataset.sectionId,
            html,
            variant: this.currentVariant
          }
        })
      )
    }
  }

  updateURL() {
    if (!this.currentVariant) { return }

    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`)
  }

  handleGiftCardTabClick(event) {
    const giftCardTab = event.target.closest('.gift-card-tab')

    if (!giftCardTab) { return }

    const { giftCardCategory } = giftCardTab.dataset
    const allTabs = this.giftCardTabWrapper.querySelectorAll('.gift-card-tab')

    allTabs.forEach(tab => {
      tab.classList.toggle('active', tab == giftCardTab)
    })

    this.giftCardTabContents.forEach(tabContent => {
      tabContent.classList.toggle('active', tabContent.dataset.giftCardCategory === giftCardCategory)
    })

    const activeTabContent = this.querySelector('.gift-card-tab-content.active')

    activeTabContent.querySelector('[data-variant-option]').checked = true

    this.dispatchEvent(new CustomEvent('change'))
  }

  getProductInfo() {
    const requestedVariantId = this.currentVariant.id
    if (this.productInfo.has(requestedVariantId)) {
      return this.productInfo.get(requestedVariantId)
    }

    this.productInfo.set(
      requestedVariantId,
      fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.sectionId}`)
        .then((response) => response.text())
        .then((responseText) => new DOMParser().parseFromString(responseText, 'text/html'))
    )

    return this.productInfo.get(requestedVariantId)
  }
}

customElements.define('gift-card-variant-picker', GiftCardVariantPicker)